import dayjs from 'dayjs';
import * as type from '../actions/types';
import { dateRangeOptions } from '../utils/insights/insightHelpers';

const today = dayjs().startOf('day');
const defaultOption = dateRangeOptions.find((item) => item.value === '3_months');

const initialState = {
  startDate: today.subtract(defaultOption.dateRange, defaultOption.dateUnit),
  endDate: today,
  dateRange: defaultOption.dateRange,
  dateUnit: defaultOption.dateUnit,
  value: defaultOption.value, // string or number so the dropdown is accurate
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.SET_SEARCH_DATES:
      const searchStartDate = dayjs(action.payload.startDate, 'YYYY-MM-DD').startOf('day');
      const searchEndDate = dayjs(action.payload.endDate, 'YYYY-MM-DD').startOf('day');

      return {
        ...state,
        dateRange: searchEndDate.diff(searchStartDate, 'day'),
        startDate: searchStartDate,
        endDate: searchEndDate,
        dateUnit: 'day',
        value: null,
      };
    case type.SET_DATE_RANGE:
      const newDateRange = action.payload;

      const option = dateRangeOptions.find((item) => item.value === newDateRange);
      // Date range can be in months, not just days
      // NOTE: These are the PREVIOUS months. e.g. if we're in mid july, 1_month is June 1 to June 30
      if (option) {
        if (typeof option.dateRange === 'number') {
          const endDate = dayjs().startOf('day');

          return {
            ...state,
            dateRange: option.dateRange,
            startDate: endDate.subtract(option.dateRange, option.dateUnit),
            endDate,
            dateUnit: option.dateUnit,
            value: option.value,
          };
        }

        if (option.value === 'yesterday') {
          return {
            ...state,
            dateRange: 0,
            startDate: dayjs().subtract(1, 'day'),
            endDate: dayjs().subtract(1, 'day'),
            dateUnit: 'day',
            value: option.value,
          };
        }

        if (option.value === 'custom') {
          return {
            ...state,
            value: option.value,
          };
        }

        if (option.value === 'all_time') {
          const startDate = dayjs('2020-01-01').startOf('day');
          const endDate = dayjs().startOf('day');

          return {
            ...state,
            dateRange: endDate.diff(startDate, 'day'),
            startDate,
            endDate,
            dateUnit: 'day',
            value: option.value,
          };
        }
      }

      // no option found
      return state;
    default:
      return state;
  }
};
